import { render, staticRenderFns } from "./elecSign.vue?vue&type=template&id=52acefac&scoped=true&"
import script from "./elecSign.vue?vue&type=script&lang=js&"
export * from "./elecSign.vue?vue&type=script&lang=js&"
import style0 from "./elecSign.vue?vue&type=style&index=0&id=52acefac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52acefac",
  null
  
)

export default component.exports